export interface IAppSettings {
    productionMode: boolean;
    googleAnalyticsId: string;
}

export const AppSettings: IAppSettings = (window as any).env; 


// WEBPACK FOOTER //
// ./src/helpers/appSettings.ts